import { render, staticRenderFns } from "./cgl-dashboard.vue?vue&type=template&id=5ea5d3d6&"
import script from "./cgl-dashboard.vue?vue&type=script&lang=js&"
export * from "./cgl-dashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports